var React = require('react');

function DnsLeakTest (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21 32C27.0751 32 32 27.0751 32 21C32 14.9249 27.0751 10 21 10C14.9249 10 10 14.9249 10 21C10 27.0751 14.9249 32 21 32Z","stroke":"#E8EFFF","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M29 29L38.5 38.5","stroke":"#E8EFFF","strokeWidth":"2","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M24 22.5C24 24.1569 22.6569 25.5 21 25.5C19.3431 25.5 18 24.1569 18 22.5C18 20.8431 21 16 21 16C21 16 24 20.8431 24 22.5Z","fill":"#E8EFFF","key":2})]);
}

DnsLeakTest.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = DnsLeakTest;

DnsLeakTest.default = DnsLeakTest;
